import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { CurrencyProvider } from './contexts/CurrencyContext';
import { ToastContainer } from 'react-toastify';

// Components
import Layout from './components/Layout/Layout';
import Login from './components/authentication/Login/Login';
import SignUp from './components/authentication/SignUp/SignUp';
import ForgotPassword from './components/authentication/ForgotPassword/ForgotPassword';
import ResetPassword from './components/authentication/ResetPassword/ResetPassword';
import ProductView from './components/product/Products/ProductView';
import ContactUs from './components/Contact/ContactUs';
import Checkout from './components/Checkout/Checkout';
import Cart from './components/product/Cart/Cart';
import ProductCard from './components/common/ProductCardComponent/Index';
import Home from './pages/Home/Home';
import ProductList from './pages/ProductsList/Index';
import ViewProduct from './pages/ViewProduct/Index';
import OrderConfirmationPage from './components/Checkout/OrderConfirmation';
import AboutUs from './pages/AboutUs/aboutUs';
import UserProfile from './pages/UserProfile/Profile';
import SearchResult from './pages/SearchResult/searchResult';
import Category from './pages/Categories/Index';
import SubCategoryList from './pages/subCategories/Index';
import Collection from './pages/Collections/Index';
import WishlistPage from './pages/Wishlist/Index';
import OrderInformation from './pages/orderInformation/Index';
import ReturnsManagement from './pages/Returns/Index';
import UnsubscribeComponent from './components/common/UnsubscribeComponent';
import SalePage from './pages/Sales/Index';
import PrivacyPolicy from './components/common/PrivacyPolicy';
import TestimonialPage from './pages/Testimonials/Index';


const App = () => {
  return (
    <CurrencyProvider>
      <Router>
        {/* Toast Container Configuration */}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          style={{
            zIndex: 9999,
          }}
          toastStyle={{
            backgroundColor: '#fff',
            color: '#333',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            fontSize: '14px',
            padding: '12px 16px',
            fontFamily: 'Arial, sans-serif'
          }}
        />

        <Routes>
          <Route path="/" element={<Layout showNavbar={true} showFooter={true}><Home /></Layout>} />
          <Route path="/login" element={<Layout showNavbar={true} showFooter={false}><Login /></Layout>} />
          <Route path="/signup" element={<Layout showNavbar={true} showFooter={false}><SignUp /></Layout>} />
          <Route path="/forgot-password" element={<Layout showNavbar={true} showFooter={false}><ForgotPassword /></Layout>} />
          <Route path="/reset-password" element={<Layout showNavbar={true} showFooter={false}><ResetPassword /></Layout>} />
          <Route path="/product-view" element={<Layout showNavbar={true} showFooter={false}><ProductView /></Layout>} />
          <Route path="/contact-us" element={<Layout showNavbar={true} showFooter={true}><ContactUs /></Layout>} />
          <Route path="/checkout" element={<Layout showNavbar={true} showFooter={true}><Checkout /></Layout>} />
          <Route path="/cart" element={<Layout showNavbar={true} showFooter={true}><Cart /></Layout>} />
          <Route path="/home" element={<Layout showNavbar={true} showFooter={true}><Home /></Layout>} />
          <Route path="/product-list" element={<Layout showNavbar={true} showFooter={true}><ProductList /></Layout>} />
          <Route path="/product-card" element={<Layout showNavbar={true} showFooter={true}><ProductCard /></Layout>} />
          <Route path="/product/:slug" element={<Layout showNavbar={true} showFooter={true}><ViewProduct /></Layout>} />
          <Route path="/order-confirmation" element={<Layout showNavbar={true} showFooter={true}><OrderConfirmationPage /></Layout>} />
          <Route path="/about-us" element={<Layout showNavbar={true} showFooter={false}><AboutUs /></Layout>} />
          <Route path="/profile" element={<Layout showNavbar={true} showFooter={true}><UserProfile /></Layout>} />
          <Route path="/search" element={<Layout showNavbar={true} showFooter={true}><SearchResult /></Layout>} />
          <Route path="/category/:slug" element={<Layout showNavbar={true} showFooter={true}><Category /></Layout>} />
          <Route path="/subcategory/:slug" element={<Layout showNavbar={true} showFooter={true}><SubCategoryList /></Layout>} />
          <Route path="/collection/:slug" element={<Layout showNavbar={true} showFooter={true}><Collection /></Layout>} />
          <Route path="/wishlist" element={<Layout showNavbar={true} showFooter={true}><WishlistPage /></Layout>} />
          <Route path="/orderinformation/:invoiceNumber" element={<Layout showNavbar={true} showFooter={true}><OrderInformation /></Layout>} />
          <Route path="/returns/:invoiceNumber/:orderId" element={<Layout showNavbar={true} showFooter={true}><ReturnsManagement /></Layout>} />
          <Route path="/unsubscribe" element={<UnsubscribeComponent />} />
          <Route path="/sale" element={<Layout showNavbar={true} showFooter={true}><SalePage /></Layout>} />
          <Route path="/privacy-policy" element={<Layout showNavbar={true} showFooter={true}><PrivacyPolicy /></Layout>} />
          <Route path="/testimonials" element={<Layout showNavbar={true} showFooter={true}><TestimonialPage /></Layout>} />
        </Routes>
      </Router>
    </CurrencyProvider>
  );
};

export default App;